import { EnrolmentStatusLabel } from '../../../../constants/event-constants';

export const OPEN_ENROLMENT_STATUSES = [
  EnrolmentStatusLabel.enrollable,
  EnrolmentStatusLabel.queueable,
];
